"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuItemLink", {
    enumerable: true,
    get: function() {
        return MenuItemLink;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuItemLink = require("./useMenuItemLink");
const _renderMenuItemLink = require("./renderMenuItemLink");
const _useMenuItemLinkStylesstyles = require("./useMenuItemLinkStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuItemLink = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuItemLink.useMenuItemLink_unstable)(props, ref);
    (0, _useMenuItemLinkStylesstyles.useMenuItemLinkStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuItemLinkStyles_unstable')(state);
    return (0, _renderMenuItemLink.renderMenuItemLink_unstable)(state);
});
MenuItemLink.displayName = 'MenuItemLink';
